import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';

import {ChartType} from 'common/report/constants';
import {InsightsReportSectionsOverride} from 'common/report/models/insights/types';
import {DateRangeAttributes} from 'common/widgets/date-range-picker/models/date-range';
import {TimeUnit} from 'common/widgets/date-range-picker/models/types';
import {PropertyFilterAttributes} from 'common/widgets/property-filter-menu/models/property-filter';
import {CohortSegment, Segment} from 'common/widgets/query-block/segment-menu/types';
import {DisplayOptions} from 'common/report/util/insights/types';

export type BookmarkOverrides = {
  additionalFilters?: PropertyFilterAttributes[];
  chartTypeOverride?: ChartType;
  dashboard?: DashboardOrigin;
  dateRangeOverride?: DateRangeAttributes;
  // Only used in funnels and insights
  erfTreatments?: CohortSegment[];
  // Only used in funnels
  groupByOverride?: Segment[];
  // Only used in insights for overriding report sections
  reportSectionsOverride?: InsightsReportSectionsOverride;
  // Insights itself uses "sections" to store live report sections via Insights' Report::toUrlData() model class method
  sections?: InsightsReportSectionsOverride;
  // Insights itself uses "displayOptions" to store live report sections via Insights' Report::toUrlData() model class method
  displayOptions?: DisplayOptions;
  timeUnitOverride?: TimeUnit;
  trendUnitOverride?: TimeUnit;
};

// corresponds with types above
export const bookmarkOverrides = [
  `additionalFilters`,
  `chartTypeOverride`,
  `dashboard`,
  `dateRangeOverride`,
  `erfTreatments`,
  `groupByOverride`,
  `reportSectionsOverride`,
  `sections`,
  `displayOptions`,
  `timeUnitOverride`,
  `trendUnitOverride`,
];

export type DashboardOrigin = {id: number; title: string};

export function getDashboardParams(dashboard) {
  return isEmpty(dashboard) ? {} : {dashboard: pick(dashboard, [`id`, `title`])};
}
